unit Web.Dashboard.Utils;

interface

type
  TMissingEmailType = (
    ptAcademy,
    ptSchool
  );

const
  Missing_Email_Type: array[TMissingEmailType] of string = ('Academy', 'School');
  JSONDateFormat = 'yyyy-mm-dd';

function FormatDashboardPercentage(AValue, ACount: Integer): string;

function FormatDashboardAverage(AValue: Double; ACount: Integer): string;

function FormatDashboardJsonDate(ADate: TDateTime): string;

implementation

uses
  System.SysUtils;

function FormatDashboardPercentage(AValue, ACount: Integer): string;
begin
  if (AValue = 0) or (ACount = 0) then
    Result := Format('%0.2f', [0])
  else
    Result := Format('%0.2f', [(AValue / ACount * 100)]);

end;

function FormatDashboardAverage(AValue: Double; ACount: Integer): string;
begin
  if (AValue = 0) or (ACount = 0) then
    Result := '£0'
  else
    Result := Format('£%m', [(AValue / ACount)]);

end;

function FormatDashboardJsonDate(ADate: TDateTime): string;
begin
  Result := FormatDateTime(JSONDateFormat, ADate);

end;

end.
